// Types
import { TButtonColor, TButtonProps, TButtonSize, TButtonVariant, TLoadingIconPosition } from './Button.type';

export const BUTTON_COLORS: TButtonColor[] = [
  'primary',
  'secondary',
  'tertiary',
  'success',
  'warning',
  'error',
  'information'
];
export const BUTTON_COLOR: { [key in TButtonColor]: key } = {
  primary: 'primary',
  secondary: 'secondary',
  tertiary: 'tertiary',
  success: 'success',
  warning: 'warning',
  error: 'error',
  information: 'information'
};

export const BUTTON_SIZES: TButtonSize[] = [ 'sm', 'md', 'lg' ];
export const BUTTON_SIZE: { [key in TButtonSize]: key } = {
  sm: 'sm',
  md: 'md',
  lg: 'lg'
};

export const BUTTON_VARIANTS: TButtonVariant[] = [ 'solid', 'soft', 'outline', 'transparent' ];
export const BUTTON_VARIANT: { [key in TButtonVariant]: key } = {
  solid: 'solid',
  soft: 'soft',
  outline: 'outline',
  transparent: 'transparent'
};

export const BUTTON_LOADING_ICON_POSITIONS: TLoadingIconPosition[] = [ 'left', 'right' ];
export const BUTTON_LOADING_ICON_POSITION: { [key in TLoadingIconPosition]: key } = {
  left: 'left',
  right: 'right'
};

export const BUTTON_DEFAULT_PROPS: TButtonProps = {
  color: BUTTON_COLOR.primary,
  loadingIconPosition: BUTTON_LOADING_ICON_POSITION.left,
  size: BUTTON_SIZE.md,
  variant: BUTTON_VARIANT.solid
};
